module.exports = __webpack_public_path__ + "static/media/hand-receiving.8c09d7c2.svg";